<template>
	<div class="add-node-btn-box">
		<div class="add-node-btn">
			<el-popover placement="right-start" :width="270" trigger="click" :hide-after="0" :show-after="0">
				<template #reference>
					<slot name="reference">
						<el-button type="primary" icon="el-icon-plus" circle></el-button>
					</slot>
				</template>
				<div class="add-node-popover-body">
					<ul>
						<li v-for="(item,index) in nodeInfos" :key="index">
							<el-icon style="color: #ff943e;" @click="$emit('add-node',item)">
								<component :is="item.icon"/>
							</el-icon>
							<p>{{ item.title }}</p>
						</li>
					</ul>
				</div>
			</el-popover>
		</div>
	</div>
</template>

<script>
import {getFlow} from "@/components/flow/flow-context";
import {computed} from "vue";

export default {
	name: 'FlowAction',
	props: {
		nodes: {
			type: Array,
		},
	},
	setup(props, context) {
		// console.log(props.nodes)
		const nodeInfos = computed(() => Array.from(props.nodes || []).map(i => getFlow(i)))
		return {
			nodeInfos,
		}
	},
}
</script>

<style scoped lang="scss">
.add-node-btn-box {
	width: 240px;
	display: inline-flex;
	flex-shrink: 0;
	position: relative;
	z-index: 1;
}

.add-node-btn-box:before {
	content: "";
	position: absolute;
	top: 0px;
	left: 0px;
	right: 0px;
	bottom: 0px;
	z-index: -1;
	margin: auto;
	width: 2px;
	height: 100%;
	background-color: rgb(202, 202, 202);
}

.add-node-btn {
	user-select: none;
	width: 240px;
	padding: 20px 0px 32px;
	display: flex;
	justify-content: center;
	flex-shrink: 0;
	flex-grow: 1;
}

.add-node-btn span {
}

.add-node-popover-body {
}

.add-node-popover-body li {
	display: inline-block;
	width: 80px;
	text-align: center;
	padding: 10px 0;
}

.add-node-popover-body li i {
	border: 1px solid var(--el-border-color-light);
	width: 40px;
	height: 40px;
	border-radius: 50%;
	text-align: center;
	line-height: 38px;
	font-size: 18px;
	cursor: pointer;
}

.add-node-popover-body li i:hover {
	border: 1px solid #3296fa;
	background: #3296fa;
	color: #fff !important;
}

.add-node-popover-body li p {
	font-size: 12px;
	margin-top: 5px;
}
</style>
